import {AccountMedData, AccountMedDataUpsertDTO} from "../models/accountMedData";
import {authFetch} from "../auth/authFetch";

const BASE_URL = "/api/accountMedData";

export async function upsertAccountMedData(
    accountId: number,
    dto: AccountMedDataUpsertDTO
): Promise<AccountMedData> {
    const res = await authFetch(`${BASE_URL}/${accountId}`, {
        method: "PUT",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify(dto)
    });

    if (!res.ok) {
        throw new Error(await res.text());
    }

    return res.json() as Promise<AccountMedData>;
}

export async function getAccountMedDataById(accountId: number): Promise<AccountMedData | null> {
    return getAccountMedData(`${BASE_URL}/${accountId}`);
}

export async function getSharedAccountMedDataById(requesterId: number, targetId: number): Promise<AccountMedData | null> {
    return getAccountMedData(`${BASE_URL}/${requesterId}/${targetId}`);
}

async function getAccountMedData(url: string): Promise<AccountMedData | null> {
    const res = await authFetch(url, {
        method: "GET",
        headers: {"Accept": "application/json"}
    });

    if (res.status === 404) {
        return null;
    }

    if (!res.ok) {
        throw new Error(await res.text());
    }

    return res.json() as Promise<AccountMedData>;
}
